import { Outlet, Navigate } from "react-router-dom";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { isApplicationsMembershipEnabled } from "@/pages/people/_membershipServicesNavLinks";

export default function MemberElectionsLayout() {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  if (!flagsLoaded) {
    return null;
  }

  if (!isApplicationsMembershipEnabled(flags)) {
    return <Navigate to="/people/membership-services" replace />;
  }

  return <Outlet />;
}
